import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { onboardingReducer } from './advisor-onboarding.reducer';
import { AdvisorOnboardingEffects } from './advisor-onboarding.effects';
import { STORE_TYPE } from './advisor-onboarding.model';

@NgModule({
  imports: [
    StoreModule.forFeature(STORE_TYPE, onboardingReducer),
    EffectsModule.forFeature([AdvisorOnboardingEffects]),
  ],
})
export class AdvisorOnboardingStoreModule {}
